
export class WorkOrderCard {
    constructor(
        public Id: string = null,
        public BriefDescription: string = null,
        public CreatedDate: Date = null,
        public ScheduledDate: Date = null,
        public Designation: string = null,
        public Status: string = null,
        public Assignment: string = null,
        public Category: string = null,
        public Phone: string = null,
        public NumericPhone: string = null,
        public DefaultCard: boolean = false,
        public DisplayId: string = null,
    ) {
        this.formatPhoneNumberForLink();
        this.setDisplayId();
    }

    formatPhoneNumberForLink() {
        if (this.Phone && this.Phone != "N/A") {
            this.NumericPhone = this.Phone.replace(/\D/g,'');
        }
    }
    setDisplayId() {
        if(this.DisplayId != null){
            return;
        }

        if (this.Designation) {
            if (this.Status !== 'Pending Review') {
                this.DisplayId = `#${this.Id}${this.Designation[0]}`
            } else {
                this.DisplayId = `#${this.Id}TP`;
            }
        } else {
            this.DisplayId = this.Id;
        }
    }

    convertToLocaleDatetime(datetimeStr: string): string {
        let datetime = new Date(datetimeStr);
        let hour = datetime.getHours();
        let meridian;

        if (hour > 12) {
            hour -= 12;
            meridian = 'PM';
        } else if (hour === 12) {
            meridian = 'PM';
        } else if (hour === 0) {
            hour = 12;
            meridian = 'AM';
        } else {
            meridian = 'AM';
        }

        return `${datetime.getMonth() +
            1}/${datetime.getDate()}/${datetime.getFullYear()} ${hour}:${datetime.getMinutes()} ${meridian}`;
    }
}